import React from 'react';
import { Card } from './ui';

const QuotaCard = ({ player, rank, scoreLabel, averageLabel }) => {
    return (
        <Card className="mb-4 border-l-4 border-blue-500">
            <div className="flex justify-between items-start mb-3">
                <div>
                    <h3 className="font-bold text-lg text-gray-900 dark:text-gray-100">{player.name}</h3>
                    <div className="text-sm text-gray-500 dark:text-gray-400">Current Quota: <span className="font-bold text-blue-600 dark:text-blue-400">{player.current_quota}</span></div>
                </div>
                <div className="text-right">
                    <div className="text-xs text-gray-500 dark:text-gray-400 uppercase">{averageLabel} Avg</div>
                    <div className="font-bold text-lg text-gray-800 dark:text-gray-200">
                        {typeof player.average_score === "number" ? player.average_score.toFixed(2) : "N/A"}
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-2 gap-4 pt-3 border-t border-gray-100 dark:border-gray-700">
                <div className="text-center p-2 bg-gray-50 dark:bg-navy-800 rounded">
                    <div className="text-xs text-gray-500 dark:text-gray-400 mb-1">{scoreLabel} Lowest</div>
                    <div className="font-semibold text-green-600 dark:text-green-400">{player.lowest_score}</div>
                </div>
                <div className="text-center p-2 bg-gray-50 dark:bg-navy-800 rounded">
                    <div className="text-xs text-gray-500 dark:text-gray-400 mb-1">{scoreLabel} Best</div>
                    <div className="font-semibold text-blue-600 dark:text-blue-400">{player.best_score}</div>
                </div>
            </div>
        </Card>
    );
};

export default QuotaCard;
